import { render, staticRenderFns } from "./AddEntityForm.vue?vue&type=template&id=2137243d&scoped=true&"
import script from "./AddEntityForm.vue?vue&type=script&lang=js&"
export * from "./AddEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137243d",
  null
  
)

export default component.exports